import store from "@/store";
import requestService from "@/service/requestService";
import { getFunctionSettingConfigKey } from "@/store/modules/functionSetting";
import { FunctionSetting } from "@/model/FunctionSetting";
import { ShakenStorage } from "@/service/storage";

// Promise自体はUserService等でも使用している。
// ここでは最低限度の必須動作を固めて呼び出すようにしている

export class PromiseService {
  reqService: requestService;
  uketsukeExtendsId: number;

  constructor() {
    this.reqService = new requestService();
    this.uketsukeExtendsId = store.getters["ReservationDetail/uketsukeExtendsId"];
  }

  getFunctionSettingPM() {
    let promise = new Promise((resolve, reject) => {
      if (window.sessionStorage.getItem(getFunctionSettingConfigKey()) == "1") {
        // F5の場合、セッションを使って設定のロードを高速化
        store.dispatch("FunctionSetting/setStateSession");
        // タブ複製時はsessionStorageも複製される。ここで所属情報をAuthContextへ
        // 反映すると、複製元のFunctionSettingを新ログイン者の所属としてしまうため、
        // sessionStorageからの復元値は認証コンテキストを更新しない。
        resolve();
      } else {
        this.reqService.getFunctionSettingPM().then(
          (response: any) => {
            if (response) {
              store.dispatch("FunctionSetting/setState", response);
              this.saveOrganizationContext();
            }
            resolve();
          },
          (err: any) => { reject(); }
        );
      }
    });
    return promise;
  }

  /**
   * FunctionSetting全体はタブ単位のsessionStorageに留める。
   * 別IDログイン時の安全な画面遷移に必要な所属3項目だけを、経路別の
   * 認証コンテキストへ複写する。
   */
  private saveOrganizationContext(): void {
    const setting: FunctionSetting = store.getters["FunctionSetting/currentState"];
    if (!setting || !setting.groupCd || !setting.shatenCd || !setting.kyotenCd) {
      return;
    }
    const context = ShakenStorage.getActiveAuth();
    if (!context) {
      return;
    }
    if (context.organizationReady &&
      context.groupCd === setting.groupCd &&
      context.shatenCd === setting.shatenCd &&
      context.kyotenCd === setting.kyotenCd) {
      return;
    }
    ShakenStorage.updateAuth({
      groupCd: setting.groupCd,
      shatenCd: setting.shatenCd,
      kyotenCd: setting.kyotenCd,
      organizationReady: true
    });
  }

  getNewInformation() {
    this.reqService.getNewInformation()
    .then((res: any) => {
        store.commit("FunctionSetting/setInformation", res );
    });
  }

  getScenarioNo(uketsukeExtendsId: number) {
    const id: number = this.uketsukeExtendsId != 0 ? this.uketsukeExtendsId : uketsukeExtendsId;
    this.reqService.getReservationTarget(id,0)
    .then((res: any) => {
      if (res.length > 0) {
        let uketsuke = res.filter((data: any) => 
          data.uketsukeExtendId != '' && data.uketsukeExtendId == this.uketsukeExtendsId);
        store.commit("FunctionSetting/setScenarioNo", uketsuke[0].uketsukeParentNo);
      }
    });
  }
}

